import {
  AMBER,
  GREEN,
  LIGHT_GRAY,
  LIGHT_YELLOW,
  LOW_GRAY,
  MEDIUM_BLUE,
  MEDIUM_RED,
  SILVER,
} from "../../config";
import { translate } from "../../intl";
import { ControlStatus, CtoStatus, HeaderStatus } from "../../types";
import { Colors } from "../../types/colorStatusNames";

type CtoStatusMap = {
  [key in CtoStatus]?: string;
};

type ControlStatusMap = {
  [each in ControlStatus]?: string;
};

export const isAvailableCtoFilling = (status: CtoStatus): boolean =>
  [CtoStatus.UNDER_EVALUATION, CtoStatus.LIVE].includes(status);

export const isOpenCto = (status: CtoStatus): boolean =>
  [
    CtoStatus.UNDER_EVALUATION,
    CtoStatus.LIVE,
    CtoStatus.EXTENSION_REQUIRED,
  ].includes(status);

export const getColorByStatus = (ctoStatus: CtoStatus): string => {
  const colorsMap: CtoStatusMap = {
    [CtoStatus.UNDER_EVALUATION]: LIGHT_YELLOW,
    [CtoStatus.LIVE]: GREEN,
    [CtoStatus.EXTENSION_REQUIRED]: MEDIUM_RED,
    [CtoStatus.COMPLETED]: MEDIUM_BLUE,
    [CtoStatus.CANCELLED]: SILVER,
    [CtoStatus.EXPIRED]: LIGHT_GRAY,
  };

  return colorsMap[ctoStatus] || LOW_GRAY;
};

export const getLabelByStatus = (
  ctoStatus: CtoStatus,
  groupFinalized = false,
): string => {
  const statusLabelMap: CtoStatusMap = {
    [CtoStatus.UNDER_EVALUATION]: "underEvaluation",
    [CtoStatus.LIVE]: "live",
    [CtoStatus.EXTENSION_REQUIRED]: "extensionRequired",
    [CtoStatus.COMPLETED]: groupFinalized ? "finished" : "completed",
    [CtoStatus.EXPIRED]: groupFinalized ? "finished" : "expired",
    [CtoStatus.CANCELLED]: groupFinalized ? "finished" : "cancelled",
  };

  return translate(`ctoStatus.${statusLabelMap[ctoStatus]}`);
};

export const getFinishedHeaderStatus = (ctos_qty = 0): HeaderStatus => ({
  status_code: [CtoStatus.COMPLETED, CtoStatus.EXPIRED, CtoStatus.CANCELLED],
  status_color: Colors.LOW_GRAY,
  status_label: "ctoStatus.finished",
  ctos_qty,
});

export const getCompletedHeaderStatus = (ctos_qty = 0): HeaderStatus => ({
  status_code: CtoStatus.COMPLETED,
  status_color: Colors.MEDIUM_BLUE,
  status_label: "ctoStatus.completed",
  ctos_qty,
});

export const getExpiredHeaderStatus = (ctos_qty = 0): HeaderStatus => ({
  status_code: CtoStatus.EXPIRED,
  status_color: Colors.CARBON_GRAY,
  status_label: "ctoStatus.expired",
  ctos_qty,
});

export const getCancelledHeaderStatus = (ctos_qty = 0): HeaderStatus => ({
  status_code: CtoStatus.CANCELLED,
  status_color: Colors.SILVER,
  status_label: "ctoStatus.cancelled",
  ctos_qty,
});

export const getExtensionRequiredHeaderStatus = (
  ctos_qty = 0,
): HeaderStatus => ({
  status_code: CtoStatus.EXTENSION_REQUIRED,
  status_color: Colors.MEDIUM_RED,
  status_label: "ctoStatus.extensionRequired",
  ctos_qty,
});

export const getLiveHeaderStatus = (ctos_qty = 0): HeaderStatus => ({
  status_code: CtoStatus.LIVE,
  status_color: Colors.GREEN,
  status_label: "ctoStatus.live",
  ctos_qty,
});

export const getUnderEvaluationHeaderStatus = (ctos_qty = 0): HeaderStatus => ({
  status_code: CtoStatus.UNDER_EVALUATION,
  status_color: Colors.LIGHT_YELLOW,
  status_label: "ctoStatus.underEvaluation",
  ctos_qty,
});

export const getCtoHeaderStatusEmpty = (): HeaderStatus[] => [
  getFinishedHeaderStatus(),
  getExtensionRequiredHeaderStatus(),
  getLiveHeaderStatus(),
  getUnderEvaluationHeaderStatus(),
];

export const getControlColorByStatus = (
  controlStatus: ControlStatus,
): string => {
  const colorsMap: ControlStatusMap = {
    [ControlStatus.ON_GOING]: GREEN,
    [ControlStatus.LAST_WEEK]: AMBER,
    [ControlStatus.OVERDUE]: MEDIUM_RED,
    [ControlStatus.COMPLETED]: MEDIUM_BLUE,
  };

  return colorsMap[controlStatus] || LOW_GRAY;
};

export function getClassColorByStatus(
  status: CtoStatus,
): "orange" | "blue" | "purple" | "gray" {
  switch (status) {
    case CtoStatus.UNDER_EVALUATION:
      return "orange";
    case CtoStatus.LIVE:
      return "blue";
    case CtoStatus.EXTENSION_REQUIRED:
      return "purple";
    //TODO: define right color for the other statuses
    case CtoStatus.COMPLETED:
    case CtoStatus.CANCELLED:
    case CtoStatus.EXPIRED:
      return "gray";
    default:
      return "gray";
  }
}
